<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="primary white--text title">
                    COP
                </v-card-title>
                <v-card-text>
                    <date-range-selector v-model="range"></date-range-selector>
                </v-card-text>
                <v-card-text v-if="!loading">
                    <vue-plotly :data="data" :layout="layout" :options="options" ref="plotly"/>
                    <vue-plotly :data="data2" :layout="layout2" :options="options" ref="plotly"/>
                    <vue-plotly :data="data3" :layout="layout3" :options="options" ref="plotly"/>
                </v-card-text>
                <v-card-actions v-if="!loading">
                    <v-spacer></v-spacer>
                    <v-btn @click="downloadCSV()" class="accent">Download as CSV</v-btn>
                </v-card-actions>
                <v-card-text v-if="loading">
                    <loading-progress-bar :loading="loading"></loading-progress-bar>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getCOP} from '@/helper'
import VuePlotly from '../components/VuePlotly'
import DateRangeSelector from '../components/DateRangeSelector'
import LoadingProgressBar from '../components/LoadingProgressBar'
import {exportCSVFromDicts} from "@/tocsv.js"

  export default {
    name: 'Cop.vue',
    components: { LoadingProgressBar, DateRangeSelector, VuePlotly },
    data () {
      return {
        range: null,
        loading: true,
        data: [
          {
            x: [0,1,2,3000],
            y: [0,1,2,3000],
            type: 'line',
            mode: 'lines+markers'
          }
        ],
        data2: null,
        data3: null,
        options: {},
        startDate: '',
          timeout:null,
        endDate: '',
        layout: {
          title: 'COP',
          hovermode: 'closest',
          xaxis: {
            title: 'Time',
          },
          yaxis: {
            title: 'COP'
          },
        },
        layout2: {
          title: 'Cooling Load',
          hovermode: 'closest',
          xaxis: {
            title: 'Time',
          },
          yaxis: {
            title: 'Cooling Load'
          },
        },
        layout3: {
          title: 'Power',
          hovermode: 'closest',
          xaxis: {
            title: 'Time',
          },
          yaxis: {
            title: 'Power'
          },
          df: null
        }
      }
    },
    watch: {
      range() {
        this.refresh()
      }
    },
    methods: {
      downloadCSV () {
        exportCSVFromDicts(this.df)
      },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout= setTimeout(() => callback(), wait);
        },
        refresh(){
            this.debounce(this.doRefresh,200);
        },
      async doRefresh () {
        if (!this.range) return
        this.loading = true
        let result = await getCOP({
          facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
          from_date: this.range.start,
          to_date: this.range.end
        })
        this.df = result
        this.data = [
          {
            line: {
              color: 'rgb(102,178,255)',
              shape: 'spline',
              width: 1,
            },
            name: 'COP',
            x: result.timestamp,
            y: result.COP,
            type: 'scatter',
            mode: 'lines',
          }
        ]
        this.data2 = [
          {
            line: {
              color: 'rgb(102,178,255)',
              shape: 'spline',
              width: 1,
            },
            name: 'COP',
            x: result.timestamp,
            y: result.Cooling_Load,
            type: 'scatter',
            mode: 'lines',
          }
        ]
        this.data3 = [
          {
            line: {
              color: 'rgb(102,178,255)',
              shape: 'spline',
              width: 1,
            },
            name: 'COP',
            x: result.timestamp,
            y: result.power,
            type: 'scatter',
            mode: 'lines',
          }
        ]
        this.loading=false
      }
    },
    mounted () {
      this.refresh()
    }
  }
</script>

<style scoped>

</style>
